import React from "react";
import {
  getGatsbyImageData,
  GetGatsbyImageDataProps,
} from "@kontent-ai/gatsby-components/dist/image-element/get-gatsby-image-data";
import { GatsbyImage, withArtDirection } from "gatsby-plugin-image";
import { KontentImageElement } from "./KontentImageElement";
import { ImageFocalPoints } from "../../../types";
import AnimationWrapper, {
  AnimationBehaviors,
} from "../../containers/AnimationWrapper";

interface ArtDirectImageProps {
  mobileImage?: GetGatsbyImageDataProps;
  desktopImage: GetGatsbyImageDataProps;
  className?: string;
  focalPoint?: ImageFocalPoints;
  animation?: AnimationBehaviors;
}

export const ArtDirectedImageElement: React.FC<ArtDirectImageProps> = ({
  mobileImage,
  desktopImage,
  className,
  focalPoint,
  animation,
}) => {
  if (!mobileImage?.image?.url)
    return (
      <KontentImageElement
        image={desktopImage.image}
        focalPoint={focalPoint}
        animation={animation}
      />
    );

  const artDirect = withArtDirection(getGatsbyImageData(desktopImage), [
    {
      media: "(max-width: 576px)",
      image: getGatsbyImageData(mobileImage),
    },
  ]);

  if (animation) {
    return (
      <AnimationWrapper behavior={animation}>
        <GatsbyImage
          image={artDirect}
          className={className}
          alt={desktopImage.image.description || ""}
        />
      </AnimationWrapper>
    );
  }

  return (
    <GatsbyImage
      image={artDirect}
      className={className}
      alt={desktopImage.image.description || ""}
    />
  );
};
